import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { allCategory, formatCount, getHotArticles, themeOf } from "@/utils/content";

type SidebarProps = {
  activeSlug: string;
  tags: string[];
};

export default function CategorySidebar({ activeSlug, tags }: SidebarProps) {
  const allList = [{ slug: allCategory.slug, name: allCategory.name, icon: allCategory.icon, count: allCategory.count }, ...categories];
  const hot = getHotArticles(5);

  return (
    <aside className="flex w-full flex-col gap-6 lg:w-72">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">分类导航</h2>
        <ul className="mt-4 flex flex-col gap-1">
          {allList.map((item) => {
            const theme = themeOf(item.slug);
            const active = item.slug === activeSlug;
            return (
              <li key={item.slug}>
                <Link
                  to={`/category/${item.slug}`}
                  className={`flex items-center justify-between gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${
                    active ? `${theme.chip} font-semibold` : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <i className={item.icon} />
                    {item.name}
                  </span>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">
          <i className="ri-fire-line text-primary-500" />
          热传榜
        </h2>
        <ol className="mt-4 flex flex-col gap-1">
          {hot.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/article/${item.id}`}
                className="group flex items-start gap-2.5 rounded-md p-1.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="line-clamp-2 block text-xs font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </span>
                  <span className="mt-0.5 block text-xs text-foreground-500">{formatCount(item.views)} 阅读</span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      {tags.length > 0 && (
        <div className="rounded-lg border border-background-200 bg-background-50 p-5">
          <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">相关标签</h2>
          <div className="mt-4 flex flex-wrap gap-2">
            {tags.map((tag) => (
              <span key={tag} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
}